/*
  TimepointsField.jsx
*/

// Npm.
import React from 'react';

// Components.
import TextFieldOnBlur from '../../../TextFieldOnBlur';
import IconButton from '../../../IconButton';
import Button from '../../../Button';

// Icons.
import RemoveIcon from '../../../../icons/Close';

// Makes.
import { makeStyles } from '../../../../makes/makeStyles';

// Styles.
const useStyles = makeStyles(theme => ({
  root: {
    borderCollapse: 'collapse',
    width: '100%',
    tableLayout: 'fixed',
    '& > thead > tr > th': {
      fontSize: '0.75rem',
      fontWeight: 400,
      color: theme.color_text_disabled,
      padding: 0,
      textAlign: 'left',
      '&.removeDim': {
        width: 40,
      },
    },
    '& > tbody > tr > td': {
      padding: 0,
    },
    '& > tbody > tr.item > td': {
      padding: theme.space(0, 0.5, 0.5, 0),
      textAlign: 'left',
    },
  },
  removeButton: {
    padding: '6px',  // To fit inside row.
  },
  buttonIcon: {
    marginRight: theme.space(0.5),
  },
  noneText: {
    color: theme.color_divider,
    fontStyle: 'italic',
    margin: theme.space(1, 0),
  },
}));

/**
 * Field for editing ages.
 */
export default function TimepointsField({
  className,
  value,
  onChange,
  disabled = false,
  readOnly = false,
}) {

  value = value || [];

  const classes = useStyles();

  // Handlers.

  function changeItem(item, next) {
    if (!readOnly && onChange) {
      onChange(value.map(arr => arr === item ? next : arr));
    }
  }

  function removeItem(item) {
    if (!readOnly && onChange) {
      onChange(value.filter(arr => arr !== item));
    }
  }

  function handleClickAddItem() {
    if (!readOnly && onChange) {
      onChange(value.concat([[0, 1]]));
    }
  }

  return (
    <table className={classes.root}>
      {
        value.length > 0 &&
        <thead>
          <tr>
            <th>t</th>
            <th>value</th>
            { !readOnly && <th className="removeDim"></th> }
          </tr>
        </thead>
      }
      <tbody>
        {
          value.map((arr, i) => {

            function handleChangeT(value) {
              changeItem(arr, [(value && Number(value)) || 0, arr[1]]);
            }

            function handleChangeValue(value) {
              changeItem(arr, [arr[0], (value && Number(value)) || 0]);
            }

            function handleClickRemove() {
              removeItem(arr);
            }

            return (
              <tr className="item" key={i}>
                <td>
                  <TextFieldOnBlur
                    value={arr[0] || ''}
                    onChange={handleChangeT}
                    type="number"
                    placeholder="0"
                    fullWidth
                    disabled={disabled}
                    readOnly={readOnly}
                  />
                </td>
                <td>
                  <TextFieldOnBlur
                    value={arr[1] || ''}
                    onChange={handleChangeValue}
                    type="number"
                    placeholder="0.0"
                    min="0"
                    fullWidth
                    disabled={disabled}
                    readOnly={readOnly}
                  />
                </td>
                {
                  !readOnly &&
                  <td>
                    <IconButton
                      className={classes.removeButton}
                      title="Remove"
                      aria-label="remove"
                      disabled={disabled}
                      onClick={handleClickRemove}
                    >
                      <RemoveIcon />
                    </IconButton>
                  </td>
                }
              </tr>
            );
          })
        }
        {
          value.length === 0 &&
          <tr>
            <td colSpan="2">
              <div className={`${classes.noneText} body2`}>(none)</div>
            </td>
          </tr>
        }
        {
          !readOnly &&
          <tr>
            <td colSpan="2">
              <Button
                onClick={handleClickAddItem}
                disabled={disabled}
              >
                <strong className={classes.buttonIcon}>+</strong>Add Row
              </Button>
            </td>
          </tr>
        }
      </tbody>
    </table>
  );
}
